import React, { useEffect, useState } from "react";
import "./topbar.css";
import { useLocation, useHistory, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Modal } from "react-bootstrap";
import { fetchIndividualMembership } from "../../actions";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Edit, Person, RemoveRedEye, VisibilityOff } from "@material-ui/icons";
import { DCore } from "../../config";
import { call } from "redux-saga/effects";

const icons = {
  hamburgerImage: require("../../assets/images/icons/hamburger.png").default,
  logoImage: require("../../assets/images/main_logo.svg").default,
  userImage: require("../../assets/images/icons/user.png").default,
  notificationImage: require("../../assets/images/icons/notification.png")
    .default,
};

const initFormData = {
  oldPassword: "",
  newPassword: "",
};

export default function Topbar({ hasName, hasLogo }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState(initFormData);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const toggleOldPasswordVisibility = () => {
    setShowOldPassword((prevShowOldPassword) => !prevShowOldPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prevShowNewPassword) => !prevShowNewPassword);
  };

  const apiResponse = useSelector((state) => {
    const { membership } = state;
    const { application } = membership;
    return {
      application,
    };
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  var currentUser = JSON.parse(localStorage.getItem("currentUser"));

  useEffect(() => {
    if (currentUser?.sub) {
      dispatch(fetchIndividualMembership(currentUser.sub));
    }
  }, []);

  useEffect(() => {
    if (showPopup) {
      setAnchorEl(null);
    }
  }, [showPopup]);

  useEffect(() => {
    if (!showPopup) {
      setFormData(initFormData);
    }
  }, [showPopup]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (anchorEl && !anchorEl.contains(event.target)) {
        setAnchorEl(null);
      }
    }

    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    localStorage.removeItem("Token");
    sessionStorage.removeItem("application");
    history.push("/home");
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = () => {
    DCore.post("/users/api/v1/users/password/set", {
      ...formData,
      email: JSON.parse(localStorage.getItem("currentUser")).email,
    }).then(() => {
      handleClose();
      setShowPopup(false);
    });
  };

  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft">
          {useLocation().pathname != "/login" && (
            <img src={icons.hamburgerImage} alt="hamburger" />
          )}
          {!hasLogo && <img src={icons.logoImage} alt="logo" />}
          <span className="logo">IER - Membership</span>
        </div>
        {!hasName && (
          <div
            className="topRight"
            onClick={handleClick}
            style={{ marginRight: 30 }}
          >
            <div className="topbarIconNotification">
              <img src={icons.notificationImage} alt="hamburger" />
            </div>
            <div className="topAvatar">
              <img src={icons.userImage} alt="hamburger" />
            </div>
            <div className="topbarNames">
              <span>{currentUser?.given_name}</span>
              <span>{`${
                apiResponse.application ? "Member" : "Applicant"
              }`}</span>
            </div>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Link to="/profile" style={{ textDecoration: "none", color: "black" }} onClick={handleCloseMenu}>
                <MenuItem>
                  <ListItemIcon>
                    <Person />
                  </ListItemIcon>
                  My Profile
                </MenuItem>
              </Link>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  setShowPopup(true);
                }}
              >
                <ListItemIcon>
                  <Edit />
                </ListItemIcon>
                Change Password
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <ExitToAppIcon />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
      {showPopup && (
        <Modal
          show={showPopup}
          onHide={() => {
            setShowPopup(false);
          }}
          centered
        >
          <Modal.Header style={{ background: "#0e348a", color: "white" }}>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "20px",
                paddingRight: "20px",
                paddingLeft: "10px",
                paddingBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "20px",
                  width: "100%",
                  gap: "10px",
                }}
              >
                <label
                  style={{
                    textAlign: "right",
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "46px",
                    letterSpacing: "0px",
                    color: "#000",
                  }}
                >
                  Old Password
                </label>
                <div style={{ position: "relative", width: "70%" }}>
                  <input
                    type={showOldPassword ? "text" : "password"}
                    name="oldPassword"
                    value={formData.oldPassword}
                    onChange={(e) =>
                      handleChange("oldPassword", e.target.value)
                    }
                    style={{
                      border: "3px solid #0e348a",
                      borderRadius: "3px",
                      paddingLeft: "10px",
                      width: "100%",
                    }}
                  />
                  {showOldPassword ? (
                    <VisibilityOff
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        cursor: "pointer",
                        transform: "translateY(-50%)",
                      }}
                      onClick={toggleOldPasswordVisibility}
                    />
                  ) : (
                    <RemoveRedEye
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        cursor: "pointer",
                        transform: "translateY(-50%)",
                      }}
                      onClick={toggleOldPasswordVisibility}
                    />
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  gap: "10px",
                }}
              >
                <label
                  style={{
                    textAlign: "right",
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "46px",
                    letterSpacing: "0px",
                    color: "#000",
                  }}
                >
                  New Password
                </label>
                <div style={{ position: "relative", width: "70%" }}>
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={(e) =>
                      handleChange("newPassword", e.target.value)
                    }
                    style={{
                      border: "3px solid #0e348a",
                      borderRadius: "3px",
                      paddingLeft: "10px",
                      width: "100%",
                    }}
                  />
                  {showNewPassword ? (
                    <VisibilityOff
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        cursor: "pointer",
                        transform: "translateY(-50%)",
                      }}
                      onClick={toggleNewPasswordVisibility}
                    />
                  ) : (
                    <RemoveRedEye
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        cursor: "pointer",
                        transform: "translateY(-50%)",
                      }}
                      onClick={toggleNewPasswordVisibility}
                    />
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
                paddingLeft: "20px",
                marginTop: "20px",
              }}
            >
              <button
                className="a_cancel"
                onClick={() => setShowPopup(false)}
                style={{
                  height: "40px",
                  outline: "none",
                  fontFamily: "Roboto",
                  cursor: "pointer",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  paddingLeft: "40px",
                  paddingRight: "40px",
                  lineHeight: "30px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  borderRadius: "3px",
                  border: "2px solid #9c9c9c",
                  color: "#9c9c9c",
                }}
              >
                CANCEL
              </button>
              <button
                className="a_confirm"
                onClick={handlePasswordChange}
                style={{
                  height: "40px",
                  outline: "none",
                  fontFamily: "Roboto",
                  cursor: "pointer",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  paddingLeft: "40px",
                  paddingRight: "40px",
                  lineHeight: "30px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  borderRadius: "3px",
                  color: "#fff",
                  backgroundColor: "#0c8444",
                  border: "none",
                }}
              >
                CONFIRM
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
